import { render, staticRenderFns } from "./CustomFormGroup.vue?vue&type=template&id=8c1187b6&"
import script from "./CustomFormGroup.vue?vue&type=script&lang=js&"
export * from "./CustomFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports